<template>
  <sc-page-base
    :title="title">
    <div class="box">
      <div class="has-text-right page-analytic-detail">
        <sc-button
          class="is-primary"
          @click="exportExcel"
          :loading="loadingExports">
          <span>Exportar para Excel</span>
          <sc-icon
            icon="file-excel"
            size="is-small" />
        </sc-button>
      </div>

      <sc-table
        :data="detail"
        :loading="loading"
        default-sort="invoice"
        paginated>
        <template slot-scope="{ row }">

          <sc-table-column
            field="invoice"
            label="Nota Fiscal"
            sortable>
            {{ row.invoice }}
          </sc-table-column>

          <sc-table-column
            field="invoice_serie"
            label="Série NF"
            sortable>
            {{ row.invoice_serie }}
          </sc-table-column>

          <sc-table-column
            field="order_number"
            label="Pedido de Entrega">
            {{ row.order_number }}
          </sc-table-column>

          <sc-table-column
            field="logistic_provider_name"
            label="Transportadora">
            {{ row.logistic_provider_name }}
          </sc-table-column>

          <sc-table-column
            field="warehouse"
            label="Centro de Distribuição">
            {{ row.warehouse }}
          </sc-table-column>

          <sc-table-column
            field="dispatch_date"
            label="Data Despacho">
            {{ row.dispatch_date | date('DD/MM/YYYY') }}
          </sc-table-column>

          <sc-table-column
            field="tms_freight_value"
            label="Valor Frete TMS">
            {{ row.tms_freight_value | currency }}
          </sc-table-column>

          <sc-table-column
            field="logistic_provider_freight_value"
            label="Valor Frete Transportadora">
            {{ row.logistic_provider_freight_value | currency }}
          </sc-table-column>

        </template>

        <template slot="bottom-left">
          <sc-table-per-page v-model="pagination.limit" :pageListNumber="pagesList" />
        </template>

        <template slot="empty">
          <sc-table-empty />
        </template>

      </sc-table>
    </div>
  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScField,
  ScSelect,
  ScPageBase,
  ScButton,
  ScIcon,
  ScTable,
  ScTableColumn,
  ScTableEmpty,
  ScTablePerPage,
  ScToast,
} from '@intelipost-js/secure-components';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/reconAnalyticDetail');

export default {
  name: 'page-analytics-detail',
  data() {
    return {
      title: 'Detalhe do Indicador de Conciliação',
      rowsPerPage: 1,
      pagesList: [25, 50],
      pagination: {
        page: 1,
        limit: 25,
      },
    };
  },
  computed: {
    ...mapState([
      'loadingExports',
      'loading',
      'detail',
    ]),
  },
  methods: {
    ...mapActions([
      'exportsDetail',
      'getAnalyticsDetail',
    ]),
    exportExcel() {
      const {
        warehouses,
        dateRange,
      } = this.$route.query;

      const {
        id,
      } = this.$route.params;

      return this.exportsDetail({
        warehouses,
        date_range: dateRange,
        logistic_providers_name: id,
      }).then(() =>
        ScToast.success(
          'O relatório está sendo gerado, assim que finalizado estará disponível na seção Meus Arquivos.',
        ),
      );
    },
  },
  mounted() {
    const {
      warehouses,
      dateRange,
    } = this.$route.query;

    const {
      id,
    } = this.$route.params;

    this.getAnalyticsDetail({
      warehouses,
      date_range: dateRange,
      logistic_providers_id: id,
    });
  },
  components: {
    ScField,
    ScSelect,
    ScPageBase,
    ScButton,
    ScIcon,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
    ScToast,
  },
};

</script>

<style lang="scss" scoped>
.page-analytic-detail {
  margin-bottom: 10px
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/analytics-detail/PageAnalyticsDetail.vue